import React, { useState, useEffect, useCallback, useRef } from 'react';
import Constant from '@/common/constant/Constant';
import {
    IconButton,
    Button,
    MenuItem,
    Popover,
    TextField,
    InputAdornment,
    DialogActions
} from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { cloneDeep } from 'lodash';
import Utils from '@/common/utils/utils';
import { isShowBtnDuplicateItem, getFieldListInCorp } from '../handler/FieldListHandler';
import { multiPanelAtom, panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import { useRecoilState } from 'recoil';
import { isUseItemInTicket, isEditField, closePanelFormManagement, validateNameOfField } from '../handler/CommonHandler';
import { deleteTagItem, searchTagItemsByFieldIdAndKeyword } from '@/service/formManagementService';
import { I18n } from 'aws-amplify';
import RenderTagItemSystemMaster from './RenderTagItemSystemMaster';
import MasterKnowledge from '@/component/formManagement/addField/MasterKnowledge';
import AutoFillMasterField from './AutoFillMasterField';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import { 
    checkIsCancelTabs, 
    isHiddenEditBtn, 
    validateDuplicateItemName, 
    validateAndParseKeywords,
    handleSearchInputChange,
    handleSearchKeyPress,
    handleSearchIconClick,
    processSearchResults,
    isHiddenToolsTagItems,
    isDisableEditTagFieldName
} from './handler/AddFieldTagItemHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { ExportUploader } from './components';
import { downloadTagItems } from './handler/downloadHandler';
import { uploadTagItems } from './handler/uploadHandler';
import PropTypes from 'prop-types';
import UnsavedChangesDialog from '../UnsavedChangesDialog';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom';
import { useSnackbar } from 'notistack';
import Logger from '@/common/utils/Logger';

AddFieldTagItem.propTypes = {
    triggerReloadTagItem: PropTypes.any,
    setIsLoading: PropTypes.any,
    fieldAddList: PropTypes.any,
    currentUpdateField: PropTypes.any,
    setFieldListInState: PropTypes.any,
    setFieldAddList: PropTypes.any,
    setCurrentUpdateField: PropTypes.any,
    setPanelScreen: PropTypes.any,
    API: PropTypes.any,
    corporationDetail: PropTypes.any,
    projectDetail: PropTypes.any,
    DONT_DISPLAY_SYS_FIELDS: PropTypes.any,
    parentPanelScreen: PropTypes.any,
    parentCallback: PropTypes.any,
    setIsChangeData: PropTypes.any,
    setTriggerReload: PropTypes.any,
};


export default function AddFieldTagItem(props) {
    // item menu tabs
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };
    // end item menu tabs

    const [masterKnowledge, setMasterKnowledge] = useState({
        formMaster:
            Utils.isEmptyString(props.currentUpdateField?.relatedMasterForm) ||
            props.currentUpdateField?.relatedMasterForm === Constant.RELATED_MASTER_FORM_DEFAULT
                ? ''
                : props.currentUpdateField?.relatedMasterForm,
        isAutoAddData: Utils.isEmptyString(props.currentUpdateField?.settingAutoAdd)
            ? true
            : props.currentUpdateField?.settingAutoAdd,

        listItem: Utils.isEmptyArray(props.currentUpdateField?.structure?.listItem)
            ? []
            : props.currentUpdateField.structure.listItem
    });

    const [autoFillMasterField, setAutoFillMasterField] = useState({
        formMaster: Utils.isEmptyString(props.currentUpdateField?.relatedMasterForm)
            ? ''
            : props.currentUpdateField?.relatedMasterForm,
        isAutoAddData: Utils.isEmptyString(props.currentUpdateField?.settingAutoAdd)
            ? true
            : props.currentUpdateField?.settingAutoAdd,
        relatedField: Utils.isEmptyString(props.currentUpdateField?.structure.relatedField)
            ? ''
            : props.currentUpdateField?.structure.relatedField,
        listItem: Utils.isEmptyArray(props.currentUpdateField?.structure?.listItem)
            ? []
            : props.currentUpdateField.structure.listItem,
        isAutoFill: Utils.isEmptyString(props.currentUpdateField?.structure?.isAutoFill)
            ? false
            : props.currentUpdateField.structure.isAutoFill
    });

    // more action popover
    const [currentItemSelected, setCurrentItemSelected] = useState(null);

    // list using
    const [itemUsingList, setItemUsingList] = useState([]);
    const [itemNotUsingList, setItemNotUsingList] = useState([]);

    // index
    const indexAddField = Utils.findIndexInArrayById(
        props?.currentUpdateField?.id,
        props?.fieldAddList
    );
    const [userPermissionCreateItemTag, setUserPermissionCreateItemTag] = useState(
        props.fieldAddList[indexAddField].structure.userPermissionCreateItemTag
    );
    const [isAddItem, setIsAddItem] = useState(
        props.fieldAddList[indexAddField].structure.isAddItem
    );

    // state
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [isDisableBtnSave, setIsDisableBtnSave] = useState(true);
    const defaultData = {
        settingSelectItem: cloneDeep(props.fieldAddList[indexAddField].structure.settingSelectItem),
        displayOrder: cloneDeep(props.fieldAddList[indexAddField].structure.displayOrder),
        isAddItem: props.fieldAddList[indexAddField].structure.isAddItem,
        userPermissionCreateItemTag: cloneDeep(
            props.fieldAddList[indexAddField].structure.userPermissionCreateItemTag
        ),
        itemList: cloneDeep(props.currentUpdateField.itemList),
        fieldName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, props.fieldAddList[indexAddField].name)
    };

    const initialFieldNameRef = useRef(
        Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, props.fieldAddList[indexAddField].name)
    );

    const [itemList, setItemList] = useState(
        Utils.isEmptyArray(props.currentUpdateField.itemList)
            ? []
            : cloneDeep(props.currentUpdateField.itemList)
    );

    const [isDialogDeleteItem, setIsDialogDeleteItem] = useState(false);
    const [settingSelectItem, setSettingSelectItem] = useState(
        props.fieldAddList[indexAddField].structure.settingSelectItem
    );

    const [displayOrder, setDisplayOrder] = useState(
        props.fieldAddList[indexAddField].structure.displayOrder?.length > 0
            ? props.fieldAddList[indexAddField].structure.displayOrder
            : Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE
    );

    const [selectedField, setSelectedField] = useState({
        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, props.fieldAddList[indexAddField].name),
        error: ''
    });

    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState(true);

    const [isEditItem, setIsEditItem] = useState(false);

    const [isChangeSelectItem, setIsChangeSelectItem] = useState(false);
    const [dialogNotificationWithMsg, setDialogNotificationWithMsg] = useState({
        status: false,
        msg: I18n.get('MSG_DELETED_TAG_FAIL')
    }); 

    const [itemDuplicateList, setItemDuplicateList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [searchError, setSearchError] = useState('');
    // manager edited state form, field screen, close panel atom 
    const [formPanelTabClose, setFormPanelTabClose] = useRecoilState(formPanelTabCloseManagementAtom);
    const { enqueueSnackbar } = useSnackbar();

    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);
    const [originSearchResult, setOriginSearchResult] = useState([]);

    useEffect(() => {
        itemList.forEach(item => {
            item.isEditName = false;
        });
    }, []);

    /**
     * Updates originalItemList when itemList actually changed
     * This function is called when isSearchMode is set to false
     */
    const updateOriginalItemList = useCallback(() => {
        props?.setTriggerReload(Date.now().toString());
    }, [props?.setTriggerReload]);

     useEffect(() => {
        const currentTime = Date.now();
        const diffTimeTrigger = currentTime - props.triggerReloadTagItem;
        if (props.triggerReloadTagItem && diffTimeTrigger < 3000) { // hotfix for reload tag item
            props.setIsLoading(true);
            getFieldListInCorp(props?.API, props.corporationDetail.id, props.projectDetail).then(list => {
                const fieldListInCorp = list?.filter(field => !props.DONT_DISPLAY_SYS_FIELDS?.includes(field?.sysField));
                const currentUpdateFieldId = props.currentUpdateField?.id;
                if (currentUpdateFieldId) {
                    props.setFieldListInState(fieldListInCorp);

                    let newCurrentField = fieldListInCorp.find(field => field.id === currentUpdateFieldId);
                    if (!Utils.isEmptyObject(newCurrentField)) {
                        props.setCurrentUpdateField(newCurrentField);

                        const cloneFieldAddList = cloneDeep(props.fieldAddList);
                        const currentFieldIndex = cloneFieldAddList.findIndex(field => field.id === currentUpdateFieldId);
                        if (currentFieldIndex !== -1) {
                            cloneFieldAddList[currentFieldIndex] = newCurrentField;
                            props.setFieldAddList(cloneFieldAddList);
                        }
                    }

                    if (!isSearchMode) {
                        if (newCurrentField?.itemList) {
                            setItemList(cloneDeep(newCurrentField?.itemList));
                        }
                        props.setIsLoading(false);
                    }
                    
                    if (isSearchMode && searchKeyword) {
                        handleSearchTagItems(searchKeyword);
                    }
                }
            });
        }

    
    }, [props.triggerReloadTagItem, isSearchMode]);

    // check disable btn save
    useEffect(() => {
        if (Utils.isEmptyString(selectedField?.name?.trim()) || !!selectedField?.error) {
            setIsDisableBtnSave(true);
            return;
        }

        const isUpdateFieldName = selectedField?.name?.trim() !== initialFieldNameRef.current;

        switch (settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.SYSTEM_MASTER:
                setIsDisableBtnSave(false);
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
                let isDisableBtnSaveByAutoFillField =
                    Utils.isEmptyString(autoFillMasterField.formMaster) &&
                    Utils.isEmptyString(autoFillMasterField.relatedField)
                        ? true
                        : false;

                if(isChangeSelectItem || isUpdateFieldName) {
                    setIsDisableBtnSave(false);
                } else {
                    setIsDisableBtnSave(isDisableBtnSaveByAutoFillField);

                }
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
            default: {
                /**
                 * check current field had haven setting master knowledge. 
                 * relatedMasterForm and formMaster are form id.
                 */
                if (
                    (props.currentUpdateField?.relatedMasterForm !== masterKnowledge.formMaster ||
                        props.currentUpdateField?.settingAutoAdd !==
                            masterKnowledge.isAutoAddData ||
                        isUpdateFieldName) &&
                    settingSelectItem === Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE
                ) {
                    setIsDisableBtnSave(false);
                    setFormPanelTabClose(prev => ({...prev, isDirty: true}));
                    break;
                }

                let isUpdateSetting =
                    isAddItem !== defaultData.isAddItem ||
                    (isAddItem &&
                        userPermissionCreateItemTag !== defaultData.userPermissionCreateItemTag);

                // validate item tag
                let isUpdateItem = false;
                const itemsListToCompare = isSearchMode ? originSearchResult : defaultData.itemList;
                for (const item of itemList) {
                    const isAddNewItem = item.id.includes('item_new');
                    if (Utils.isEmptyString(item.name) && !isAddNewItem) {
                        isUpdateItem = false;
                        break;
                    }
                    let indexExist = Utils.findIndexInArrayById(item.id, itemsListToCompare);
                    if (indexExist === -1) {
                        isUpdateItem = item.isErrorValidate ? false : true;
                    } else {
                        isUpdateItem =
                            item.name !== itemsListToCompare[indexExist].name ||
                            item.isCheckbox !== itemsListToCompare[indexExist].isCheckbox ||
                            item.no !== itemsListToCompare[indexExist].no
                                ? true
                                : isUpdateItem;
                    }
                }

                let isDisableSaveButton = true;
                if (isChangeSelectItem) {
                    isDisableSaveButton = !isChangeSelectItem;
                } else {
                    isDisableSaveButton = !isUpdateSetting && !isUpdateItem && !isUpdateFieldName;
                }
                setIsDisableBtnSave(isDisableSaveButton);
                setFormPanelTabClose(prev => ({...prev, isDirty: !isDisableSaveButton}));
            }
        }
    }, [
        itemList,
        settingSelectItem,
        isAddItem,
        userPermissionCreateItemTag,
        masterKnowledge,
        autoFillMasterField,
        selectedField?.name,
        selectedField?.error,
        originSearchResult
    ]);

    useEffect(() => {
        let itemUsingListForUpdate = [];
        let itemNotUsingListForUpdateForUpdate = [];
        let itemListForClone = cloneDeep(itemList);
        let sortBy = isSearchMode ? Constant.SORT_BY.ASC : displayOrder;

        itemListForClone.forEach(item => {
            if (item.isCheckbox) {
                itemUsingListForUpdate.push(item);
            } else {
                itemNotUsingListForUpdateForUpdate.push(item);
            }
        });
        // sort itemNotUsingList by abc
        itemNotUsingListForUpdateForUpdate.sort((item1, item2) => {
            return item1.name.localeCompare(item2.name);
        });

        // sort by order
        switch (sortBy) {
            // sort by order
            case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
                itemUsingListForUpdate.sort((item1, item2) => {
                    return item1.no - item2.no;
                });
                break;
            // sort by dictionary
            case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                itemUsingListForUpdate = itemUsingListForUpdate.sort((a, b) => {
                    let nameA = a.name;
                    let nameB = b.name;
                    return nameA.localeCompare(nameB);
                });
                break;
            // sort by hits number order
            case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                itemUsingListForUpdate.sort((item1, item2) => {
                    if (item1.hitNumber > item2.hitNumber) {
                        return -1;
                    }
                    if (item1.hitNumber < item2.hitNumber) {
                        return 1;
                    }
                    if (item1.hitNumber === item2.hitNumber) {
                        if (Number(item1.no) < Number(item2.no)) {
                            return -1;
                        } else {
                            return 1;
                        }
                    }
                    return 0;
                });
                break;
            case Constant.SORT_BY.ASC: {
                itemUsingListForUpdate = Utils.sortByCreatedAtAsc(itemUsingListForUpdate);
                itemNotUsingListForUpdateForUpdate = Utils.sortByCreatedAtAsc(itemNotUsingListForUpdateForUpdate);
                break;
            }
            default:
                itemUsingListForUpdate.sort((item1, item2) => {
                    return item1.no - item2.no;
                });
                break;
        }
        if (isSearchMode) {
            //search mode -> expand all list if list have items.
            if (!Utils.isEmptyArray(itemUsingListForUpdate)) {
                setUseButtonCollapse(false);
            }
            if (!Utils.isEmptyArray(itemNotUsingListForUpdateForUpdate)){
                setUnUseButtonCollapse(false);

            }
        }
        
        // update state
        setItemUsingList([...itemUsingListForUpdate]);
        setItemNotUsingList(itemNotUsingListForUpdateForUpdate);
    }, [itemList, displayOrder, isSearchMode]);

    const argsAll = {
        ...props,
        settingSelectItem,
        masterKnowledge,
        autoFillMasterField,
        isDisableBtnSave,
        defaultData,
        itemList
    };

    useEffect(() => {
        let isCancel = checkIsCancelTabs(argsAll);
        if (props.hasOwnProperty('parentCallback')) {
            props.parentCallback(isCancel);
        } else {
            //do something else
        }
    }, [checkIsCancelTabs, argsAll]);

    // uef listen change data from AddFieldItem Screen
    useEffect(() => {
        if (!isDisableBtnSave) {
            setFormPanelTabClose(prev => ({...prev, isDirty: true}));
        }
    }, [isDisableBtnSave]);


    // btn onClickBtnCloseDialog
    const onClickBtnCloseDialogDeleteItem = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setIsDialogDeleteItem(false);
    };

    /** handler onCancelAddFieldTagItem - Handler for 閉じる button */
    const onCancelAddFieldTagItem = event => {
        switch (settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                // check master knowledge
                if (
                    props.currentUpdateField?.relatedMasterForm !== masterKnowledge.formMaster ||
                    props.currentUpdateField?.settingAutoAdd !== masterKnowledge.isAutoAddData
                ) {
                    break;
                }

                // check update item
                let isUpdateItem = false;
                for (const newItem of masterKnowledge.listItem) {
                    let currentItem = props.currentUpdateField?.structure?.listItem?.find(
                        o => o.itemId === newItem.itemId
                    );
                    if (
                        newItem.isActive !== currentItem?.isActive ||
                        newItem.order !== currentItem?.order
                    ) {
                        isUpdateItem = true;
                        break;
                    }
                }

                if (!isUpdateItem) {
                    const isUpdateFieldName = selectedField?.name?.trim() !== initialFieldNameRef.current;
                    if (!isUpdateFieldName) {
                        props.setPanelScreen(props.parentPanelScreen);
                        return;
                    }
                }
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
                // check master knowledge
                if (
                    props.currentUpdateField?.relatedMasterForm !==
                        autoFillMasterField.formMaster ||
                    props.currentUpdateField?.settingAutoAdd !==
                        autoFillMasterField.isAutoAddData ||
                    props.currentUpdateField?.relatedField !== autoFillMasterField.relatedField
                ) {
                    break;
                }

                // check update item
                let isUpdateAutoFillItem = false;
                for (const newItem of autoFillMasterField.listItem) {
                    let currentItem = props.currentUpdateField?.structure?.listItem?.find(
                        o => o.itemId === newItem.itemId
                    );
                    if (
                        newItem.isActive !== currentItem?.isActive ||
                        newItem.order !== currentItem?.order
                    ) {
                        isUpdateAutoFillItem = true;
                        break;
                    }
                }

                if (!isUpdateAutoFillItem) {
                    const isUpdateFieldName = selectedField?.name?.trim() !== initialFieldNameRef.current;
                    if (!isUpdateFieldName) {
                        props.setPanelScreen(props.parentPanelScreen);
                        return;
                    }
                }
                break;
            default:
                // if not change data then go to screen parent
                if (isDisableBtnSave) {
                    const isUpdateFieldName = selectedField?.name?.trim() !== initialFieldNameRef.current;
                    if (!isUpdateFieldName) {
                        props.setPanelScreen(props.parentPanelScreen);
                        setItemDuplicateList([]);
                        return;
                    }
                }
                break;
        }
        // Set isCloseScreen flag for 閉じる button
        setFormPanelTabClose(prev => ({
            ...prev,
            isDirty: true,
            isCloseScreen: true
        }));
        props?.setIsOpenUnsavedChangesDialog(true);
    };

    // onBlurTextInput
    const onBlurTextInput = (event, field) => {
        let cloneItemList = cloneDeep(itemList);
        const isAddNewItem = field.id.includes('item_new');
        let index = Utils.findIndexInArrayById(field.id, cloneItemList);

        let textValue = event.target.value;
        let textValueTrim = textValue.trim();

        if (
            (Utils.isEmptyString(textValueTrim) && !isAddNewItem) ||
            textValue.length > Constant.NAME_TAG_FIELD_MAX_LENGTH
        ) {
            cloneItemList[index].isErrorValidate = true;
            cloneItemList[index].errorMsg =
                !isAddNewItem &&
                (Utils.isEmptyString(textValueTrim) ||
                    Utils.isEmptyString(cloneItemList[index].name))
                    ? I18n.get('TAGMSG001')
                    : `${Constant.NAME_TAG_FIELD_MAX_LENGTH}文字以下で入力してください。`;
        } else {
            cloneItemList[index].isErrorValidate = false;
            cloneItemList[index].isEditName = false;
        }

        if(isAddNewItem && Utils.isEmptyString(textValueTrim)) {
            cloneItemList[index].isEditName = true;
        }
        
        cloneItemList[index].isAutoFocus = false;
        setItemList(cloneItemList);

        if (isEditItem) {
            setIsEditName(field, false);
            setIsEditItem(false);
        }
    };

    /** handler onAddItem */
    const onAddItem = event => {
        setUseButtonCollapse(false);

        let item = {
            id: `${Date.now().toString()}_item_new`,
            name: '',
            isCheckbox: true,
            isErrorValidate: false,
            errorMsg: '',
            isEditName: true,
            hitNumber: 0,
            no: itemList.length + 1
        };
        let cloneItemList = [...itemList];
        cloneItemList.push(item);
        setItemList(cloneItemList);
        setIsEditItem(false);
    };

    /** handler onDeleteItem */
    const onDeleteItem = field => {
        if (!field.id.includes('item_new')) {
            setIsDialogDeleteItem(true);
            return;
        }
        let cloneItemList = cloneDeep(itemList);

        let index = Utils.findIndexInArrayById(field.id, cloneItemList);

        cloneItemList.splice(index, 1);
        
        if (isSearchMode) {
            setItemList(cloneItemList);
        } else {
            reOrderItemListAfterDeleted(cloneItemList, itemUsingList);
        }
    };

    /** handler onDuplicateItem */
    const onDuplicateItem = cloneItem => {
        const newNo = isSearchMode 
            ? cloneItem.no
            : itemUsingList.length;
        
        let item = {
            id: `${Date.now().toString()}_item_new`,
            name: `${cloneItem.name} - Copy`,
            isCheckbox: cloneItem.isCheckbox,
            isErrorValidate: false,
            errorMsg: '',
            isEditName: true,
            no: newNo
        };
        let cloneItemList = [...itemList];
        cloneItemList.push(item);
        
        if (isSearchMode) {
            setItemList(cloneItemList);
        } else {
            reOrderItemList(cloneItemList, itemUsingList);
        }
    };

    /** handler setIsEditName */
    const setIsEditName = (field, status) => {
        if (!isEditField(props.currentUpdateField, props)) {
            return;
        }
        let cloneItemList = cloneDeep(itemList);
        let index = Utils.findIndexInArrayById(field.id, cloneItemList);
        cloneItemList[index].isEditName = status;
        setItemList(cloneItemList);
    };

    /** handler onKeyPressTextInputName */
    const onKeyPressTextInputName = (event, field) => {
        const isAddNewItem = field.id.includes('item_new');
        // if event diff enter then return
        if (event.key !== 'Enter') {
            return;
        }

        let textValue = event.target.value;

        let cloneItemList = [...itemList];

        let index = Utils.findIndexInArrayById(field.id, cloneItemList);

        cloneItemList[index].name = textValue;
        let textValueTrim = textValue.trim();

        if (
            (Utils.isEmptyString(textValueTrim) && !isAddNewItem) ||
            textValueTrim.length > Constant.NAME_TAG_FIELD_MAX_LENGTH
        ) {
            cloneItemList[index].isErrorValidate = true;
            cloneItemList[index].errorMsg =
                Utils.isEmptyString(textValueTrim) && !isAddNewItem
                    ? I18n.get('TAGMSG001')
                    : `${Constant.NAME_TAG_FIELD_MAX_LENGTH}文字以下で入力してください。`;
        } else {
            cloneItemList[index].isErrorValidate = false;
            cloneItemList[index].isEditName = false;
        }

        if(isAddNewItem && Utils.isEmptyString(textValueTrim)) {
            cloneItemList[index].isEditName = true;
        }


        setItemList(cloneItemList);
        onAddItem(event);
    };

    /** handler onChangeTextInputName */
    const onChangeTextInputName = (event, field) => {
        event.preventDefault();
        const isAddNewItem = field.id.includes('item_new');
        let textValue = event.target.value;

        let cloneItemList = [...itemList];

        let index = Utils.findIndexInArrayById(field.id, cloneItemList);
        cloneItemList[index].name = textValue;


        let textValueTrim = textValue.trim();

        if (
            (Utils.isEmptyString(textValueTrim) && !isAddNewItem) ||
            textValueTrim.length > Constant.NAME_TAG_FIELD_MAX_LENGTH
        ) {
            cloneItemList[index].isErrorValidate = true;
            cloneItemList[index].errorMsg = Utils.isEmptyString(textValueTrim) && !isAddNewItem
                ? I18n.get('TAGMSG001')
                : `${Constant.NAME_TAG_FIELD_MAX_LENGTH}文字以下で入力してください。`;
        } else {
            cloneItemList[index].isErrorValidate = false;
        }

        cloneItemList[index].isAutoFocus = true;
        setItemList(cloneItemList);
    };

    /** handler onChangeUsingItem */
    const onChangeUsingItem = (event, field, isUsingItem) => {
        if (!isEditField(props.currentUpdateField, props)) {
            return;
        }
        let cloneItemList = cloneDeep(itemList);

        let index = Utils.findIndexInArrayById(field.id, cloneItemList);

        cloneItemList[index].isCheckbox = isUsingItem;
        // Update structure.isShowItemInTicket if structure exists
        if (cloneItemList[index].structure && typeof cloneItemList[index].structure === 'object') {
            cloneItemList[index].structure.isShowItemInTicket = isUsingItem;
        }
        // item using list
        let itemUsingListClone = cloneDeep(itemUsingList);
        if (isUsingItem) {
            setUseButtonCollapse(false);
            itemUsingListClone.push(field);
        } else {
            setUnUseButtonCollapse(false);
            itemUsingListClone = Utils.removeItemInArrayById(field.id, itemUsingListClone);
        }

        setItemUsingList(itemUsingListClone);
        // render order item list
        reOrderItemList(cloneItemList, itemUsingListClone);
    };

    /** Handler submit delete field tag item */
    const onSubmitDeleteFieldTagItem = () => {
        props.setIsLoading(true);

        deleteTagItem(props?.API, currentItemSelected?.id)
            .then(async data => {
                props?.setIsLoading(false);
                if (!data?.status) {
                    return setDialogNotificationWithMsg(pre => {
                        return {
                            ...pre,
                            status: true
                        };
                    });
                }

                let cloneItemList = cloneDeep(itemList);
                let index = Utils.findIndexInArrayById(currentItemSelected?.id, cloneItemList);
                if (index !== -1) {
                    cloneItemList.splice(index, 1);
                    setItemList(cloneItemList);
                }

                const cloneFieldAddList = cloneDeep(props.fieldAddList);
                if (cloneFieldAddList[indexAddField]) {
                    let isUpdateItemListState = false;
                    if (!Utils.isEmptyArray(cloneFieldAddList[indexAddField].itemList)) {
                        cloneFieldAddList[indexAddField].itemList = cloneFieldAddList[indexAddField].itemList.filter(item => item.id !== currentItemSelected?.id);
                        isUpdateItemListState = true;
                    }

                    if (!Utils.isEmptyArray(cloneFieldAddList[indexAddField].defaultItemList)) {
                        cloneFieldAddList[indexAddField].defaultItemList = cloneFieldAddList[indexAddField].defaultItemList.filter(item => item.id !== currentItemSelected?.id);
                        isUpdateItemListState = true;
                    }

                    if (isUpdateItemListState) {
                        props.setFieldAddList(cloneFieldAddList);
                    }
                }

                const cloneFieldList = cloneDeep(props?.fieldList);
                let indexInFieldList = Utils.findIndexInArrayById(props?.currentUpdateField?.id, cloneFieldList);
                if (indexInFieldList !== -1) {
                    cloneFieldList[indexInFieldList].itemList = cloneFieldList[indexInFieldList].itemList.filter(item => item?.id !== currentItemSelected?.id);
                    cloneFieldList[indexInFieldList].defaultItemList = cloneFieldList[indexInFieldList].defaultItemList.filter(item => item?.id !== currentItemSelected?.id);
                    props?.setFieldList(cloneFieldList);
                }
            })
            .catch(err => {
                setDialogNotificationWithMsg(pre => {
                    return {
                        ...pre,
                        status: true
                    };
                });
                props.setIsLoading(false);
            });
        setCurrentItemSelected(null);
        setIsDialogDeleteItem(false);
    };

    /** handler onChangeFieldName */
    const onChangeFieldName = (event) => {
        const textValue = event.target.value;
        const textTrim = textValue.trim();

        // validate
        const validateResult = validateNameOfField(textTrim);
        const hasError = !Utils.isEmptyObject(validateResult);

        // update selectedField state
        setSelectedField({
            name: textValue,
            error: hasError ? validateResult.message : ''
        });

        // update fieldAddList
        const newName = { jp: { A: 'F', text: textTrim } };
        let cloneFieldAddList = [...props.fieldAddList];
        cloneFieldAddList[indexAddField].name = newName;

        let errors = cloneFieldAddList[indexAddField].errors || {};
        errors.name = validateResult;
        cloneFieldAddList[indexAddField].errors = errors;
        props.setFieldAddList(cloneFieldAddList);

        // enable save button on FieldList when editing name of a new field
        if (props.currentUpdateField?.id?.startsWith('dummy_')) {
            props.setIsChangeData(true);
        }
    };

    /** handler onSubmitAddFieldTagItem */
    const onSubmitAddFieldTagItem = async () => {
        switch (settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                if (Utils.isEmptyString(masterKnowledge.formMaster)) {
                    let masterKnowledgeClone = cloneDeep(masterKnowledge);
                    masterKnowledgeClone.errorFormMasterSelected = 'COMMSG014';
                    setMasterKnowledge(masterKnowledgeClone);
                    break;
                }
                props.fieldAddList[indexAddField].masterKnowledge = masterKnowledge;

                props.fieldAddList[indexAddField].relatedMasterForm = masterKnowledge.formMaster;
                props.fieldAddList[indexAddField].settingAutoAdd = masterKnowledge.isAutoAddData;
                props.fieldAddList[indexAddField].structure.listItem = masterKnowledge.listItem;
                props.fieldAddList[indexAddField].structure.settingSelectItem = settingSelectItem;
                props.fieldAddList[indexAddField].definition = Constant.FORM_DEFINITION.MASTER;

                // adding tag items
                if (
                    props?.hasOwnProperty("currentUpdateField") &&
                    Utils.getPrefixOfId(props?.currentUpdateField?.id) === Constant.ID_PREFIX.FIELD)
                {
                    props?.onClickEditTagField();
                    setIsDisableBtnSave(true);
                    setIsChangeSelectItem(false);
                    setFormPanelTabClose(prev => ({...prev, isDirty: false}));
                    initialFieldNameRef.current = selectedField?.name?.trim();
                } else {
                    props.setPanelScreen(props.parentPanelScreen);
                }
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
                if (Utils.isEmptyString(autoFillMasterField.formMaster)) {
                    let autoFillMasterFieldClone = cloneDeep(autoFillMasterField);
                    autoFillMasterFieldClone.errorFormMasterSelected = 'COMMSG014';
                    setAutoFillMasterField(autoFillMasterFieldClone);
                    break;
                }
                if (Utils.isEmptyString(autoFillMasterField.relatedField)) {
                    let autoFillMasterFieldClone = cloneDeep(autoFillMasterField);
                    autoFillMasterFieldClone.errorRelatedFieldSelected = 'COMMSG014';
                    setAutoFillMasterField(autoFillMasterFieldClone);
                    break;
                }
                props.fieldAddList[indexAddField].autoFillMasterField = autoFillMasterField;
                props.fieldAddList[indexAddField].relatedMasterForm =
                    autoFillMasterField.formMaster;
                props.fieldAddList[indexAddField].settingAutoAdd =
                    autoFillMasterField.isAutoAddData;
                props.fieldAddList[indexAddField].structure.listItem = autoFillMasterField.listItem;
                props.fieldAddList[indexAddField].structure.isAutoFill =
                    autoFillMasterField.isAutoFill;
                props.fieldAddList[indexAddField].structure.relatedField =
                    autoFillMasterField.relatedField;
                props.fieldAddList[indexAddField].structure.settingSelectItem = settingSelectItem;
                props.fieldAddList[indexAddField].definition = Constant.FORM_DEFINITION.MASTER;

                props.setPanelScreen(props.parentPanelScreen);
                break;
            default: {
                // validate text input name
                let isErrorValidate = false;
                let cloneItemList = [...itemList];
                cloneItemList = cloneItemList.filter(item => !(item.id.includes('item_new') && Utils.isEmptyString(item.name)))
                cloneItemList.forEach(item => {
                    let textNameTrim = item?.name?.trim();
                    if (
                        Utils.isEmptyString(textNameTrim) ||
                        Utils.isEmptyString(item.name) ||
                        item.name.length > Constant.NAME_TAG_FIELD_MAX_LENGTH
                    ) {
                        item.isErrorValidate = true;
                        item.isEditName = true;
                        isErrorValidate = true;
                        item.errorMsg =
                            Utils.isEmptyString(textNameTrim) || Utils.isEmptyString(item.name)
                                ? I18n.get('TAGMSG001')
                                : `${Constant.NAME_TAG_FIELD_MAX_LENGTH}文字以下で入力してください。`;
                    }
                });

                if (isErrorValidate) {
                    setIsEditItem(true);
                    setItemList(cloneItemList);
                    return;
                }

                props?.setIsLoading(true);
                const duplicateNames = await validateDuplicateItemName(cloneItemList, props?.currentUpdateField?.id);
                props?.setIsLoading(false);
                setItemDuplicateList(duplicateNames);
                if (!Utils.isEmptyArray(duplicateNames)) {
                    return;
                }

                props.fieldAddList[indexAddField].itemList = cloneItemList;
                props.fieldAddList[indexAddField].structure.settingSelectItem = settingSelectItem;
                props.fieldAddList[indexAddField].structure.displayOrder = displayOrder;
                props.fieldAddList[indexAddField].structure.isAddItem = isAddItem;
                props.fieldAddList[
                    indexAddField
                ].structure.userPermissionCreateItemTag = userPermissionCreateItemTag;

                // adding tag items
                if(props?.hasOwnProperty("currentUpdateField") && Utils.getPrefixOfId(props?.currentUpdateField?.id) === Constant.ID_PREFIX.FIELD) {
                    props?.onClickEditTagField();
                    setIsDisableBtnSave(true);
                    setIsChangeSelectItem(false);
                    setFormPanelTabClose(prev => ({...prev, isDirty: false}));
                    initialFieldNameRef.current = selectedField?.name?.trim();
                    /**
                    * search mode need to update originSearchResult to run logic check enable button save in use effect "check disable btn " default case
                    */
                    if (isSearchMode) {
                        setOriginSearchResult(cloneDeep(cloneItemList));
                    }
                }else{
                    props.setPanelScreen(props.parentPanelScreen);
                }
            }
        }
    };

    // Update number sort item
    const reOrderItemList = (itemDataList, itemUsingDataList) => {
        let newList = cloneDeep(itemDataList);

        itemUsingDataList.forEach((item, index) => {
            let indexInList = Utils.findIndexInArrayById(item.id, newList);
            if (indexInList !== -1) {
                newList[indexInList].no = index + 1;
            }
        });

        setItemList(newList);
    };

    const reOrderItemListAfterDeleted = (itemDataList, itemUsingDataList) => {
        let newList = cloneDeep(itemDataList);

        itemUsingDataList.forEach((item, index) => {
            let indexInList = Utils.findIndexInArrayById(item.id, newList);
            if (indexInList !== -1) {
                newList[indexInList].no = indexInList + 1;
            }
        });

        setItemList(newList);
    };

    /** handler onDragEnd */
    const onDragEnd = event => {
        // dropped outside the list
        if (!event.destination) {
            return;
        }

        let startIndex = event.source.index;
        let endIndex = event.destination.index;

        let itemUsingListClone = cloneDeep(itemUsingList);
        let [removed] = itemUsingListClone.splice(startIndex, 1);
        itemUsingListClone.splice(endIndex, 0, removed);
        // render order item list
        reOrderItemList(itemList, itemUsingListClone);

        setItemUsingList(itemUsingListClone);
    };

    /** handler onChangeSettingSelectItem */
    const onChangeSettingSelectItem = event => {
        let value = event.target.value;
        setSettingSelectItem(value);
        setIsChangeSelectItem(true);
        props.fieldAddList[indexAddField].structure.settingSelectItem = value;

        if (
            [
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE,
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL,
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.SYSTEM_MASTER
            ].includes(value)
        ) {
            props.fieldAddList[indexAddField].definition = Constant.FORM_DEFINITION.MASTER;
            setIsSearchMode(false);
            updateOriginalItemList();
            setSearchKeyword('');
            setSearchError('');
        } else {
            props.fieldAddList[indexAddField].definition = Constant.FORM_DEFINITION.USER;
        }
    };
    /** handler onChangeSettingSelectItem */
    const onChangeDisplayOrder = event => {
        let value = event.target.value;
        setIsDisableBtnSave(false);
        setDisplayOrder(value);

        // props.fieldAddList[indexAddField].structure.displayOrder = value;
    };

    /** handler onBeforeDragStartHandler  */
    const onBeforeDragStartHandler = event => {
        //disable slide before drag start
        let newSetting = { ...settingSlideRecoilState };
        newSetting.disable = true;

        setSettingSlideRecoilState(newSetting);
    };

    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            setUnUseButtonCollapse(true);
        }
    };

    const isDisableTools = () => {
        return (
            !isEditField(props.currentUpdateField, props) ||
            props.currentUpdateField.affiliationOrganization !==
                props.projectDetail.affiliationOrganization
        );
    };

    const isDisplayTools = () => {
        return (
            !isHiddenEditBtn(props) &&
            Utils.getPrefixOfId(props.fieldAddList[indexAddField]?.id) ===  Constant.ID_PREFIX.FIELD
        );
    };

    const confirmPopupDuplicateItem = () => {
        let newList = cloneDeep(itemList);

        if (Utils.isEmptyArray(itemDuplicateList)) {
            return;
        }

        let firstDuplicateName = itemDuplicateList[0];

        for (const item of newList) {
            let textNameTrim = item?.name?.trim();
            if (
                textNameTrim === firstDuplicateName
            ) {
                item.isErrorValidate = true;
                item.isEditName = true;
                break;
            }
        };
        
        setItemList(newList);
        setItemDuplicateList([])
    };


    /**
     * Handles search tag items by field ID and keywords
     * - Validates keywords
     * - Calls search API
     * - Formats and displays results
     */
    const handleSearchTagItems = useCallback(async (keyword) => {
        const keywords = validateAndParseKeywords(keyword);
        
        if (!keywords) {
            setIsSearchMode(false);
            updateOriginalItemList();
            setSearchError('');
            return;
        }

        props.setIsLoading(true);
        try {
            const searchResults = await searchTagItemsByFieldIdAndKeyword(
                props.currentUpdateField.id,
                keywords
            );
            
            const formattedResults = processSearchResults(searchResults, setSearchError);
            if (!formattedResults) {
                return setItemList([]);
            }
            const formatResult = cloneDeep(formattedResults);
            const cloneFieldAddList = cloneDeep(props.fieldAddList);
            cloneFieldAddList[indexAddField].defaultItemList = formatResult;
            props.setFieldAddList(cloneFieldAddList);
            setIsSearchMode(true);
            setItemList(formatResult);
            setOriginSearchResult(formatResult);
            setFormPanelTabClose(prev => ({ ...prev, isDirty: false }));
        } catch (err) {
            Logger.error('handleSearchTagItems', err);
            enqueueSnackbar(
                I18n.get('MSG-TAG-ITEM-SEARCH-EMPTY-RESULT') || 'Search failed. Please try again.',
                {
                    variant: 'error',
                    autoHideDuration: 3000
                }
            );
            setIsSearchMode(false);
            updateOriginalItemList();
        } finally {
            props.setIsLoading(false);
        }
    }, [
        props.currentUpdateField.id,
        isDisableBtnSave,
        props.setIsLoading,
        enqueueSnackbar,
        updateOriginalItemList
    ]);


    const renderItemListWithUsingProject = () => {
        return displayOrder === Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE ? (
            <DragDropContext
                onDragEnd={e => onDragEnd(e)}
                onBeforeDragStart={e => onBeforeDragStartHandler(e)}
            >
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <ul
                            data-cy="tag-items-active-list"
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            // style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {itemUsingList.map((item, index) => (
                                <Draggable
                                    // isDragDisabled={true}
                                    key={item.id}
                                    draggableId={`${item.id}`}
                                    index={index}
                                    isDragDisabled={
                                        isSearchMode ||
                                        !isEditField(props.currentUpdateField, props) ||
                                        displayOrder ===
                                            Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER
                                    }
                                >
                                    {(provided, snapshot) => {
                                        return (
                                            <>
                                                <li
                                                    data-cy="tag-item-frame"
                                                    id={`${Math.random()}_tagItem_id`}
                                                    className="listField-li"
                                                    // key={`${Math.random()}_tagItem_key`}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    // style={getItemStyle(
                                                    //     snapshot.isDragging,
                                                    //     provided.draggableProps.style
                                                    // )}
                                                >
                                                    {renderItem(item, index)}
                                                </li>
                                            </>
                                        );
                                    }}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        ) : (
            <ul>
                {itemUsingList.map((item, index) => (
                    <li>{renderItem(item, index)}</li>
                ))}
            </ul>
        );
    };

    const renderItemListWithNotUsingProject = () => {
        return (
            <ul>
                {itemNotUsingList.map((item, index) => {
                    return (
                        <li>
                            {item.isEditName ? (
                                <>
                                    {isEditItem ? (
                                        <div className="lst-number">{index + 1}.</div>
                                    ) : (
                                        <></>
                                    )}
                                    <TextField
                                        // id={`${Date.now().toString()}_textInputName_id`}
                                        // key={`${Date.now().toString()}_textInputName_key`}
                                        id={`${item.id}_textInputName_id`}
                                        key={`${item.id}_textInputName_key`}
                                        placeholder="項目名"
                                        onChange={event => {
                                            onChangeTextInputName(event, item);
                                        }}
                                        // autoFocus={Utils.isEmpty(field.isAutoFocus) ? false : field.isAutoFocus}
                                        defaultValue={item.name}
                                        // value={field.name}
                                        //onKeyPress={event => onKeyPressTextInputName(event, item)}
                                        onBlur={event => onBlurTextInput(event, item)}
                                        autoFocus={true}
                                        disabled={!isEditField(props.currentUpdateField, props)}
                                        error={item.isErrorValidate}
                                        helperText={item.isErrorValidate ? item.errorMsg : ''}
                                        data-cy="tag-item-field-name"
                                        className="form-input-outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment>
                                                    <div className="item-formTag">
                                                        <>
                                                            {isEditItem ? (
                                                                <></>
                                                            ) : (
                                                                <>
                                                                    {!isUseItemInTicket(
                                                                        item,
                                                                        props.currentUpdateField
                                                                    ) && (
                                                                        <IconButton
                                                                            className="itemTools"
                                                                            onClick={event => {
                                                                                onDeleteItem(item);
                                                                                setCurrentItemSelected(
                                                                                    item
                                                                                );
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src="/assets/image/icon-tabs-delete.svg"
                                                                                alt=""
                                                                            />
                                                                        </IconButton>
                                                                    )}

                                                                    <IconButton
                                                                        className="itemTools"
                                                                        onClick={event =>
                                                                            onChangeUsingItem(
                                                                                event,
                                                                                item,
                                                                                true
                                                                            )
                                                                        }
                                                                    >
                                                                        <img
                                                                            src="/assets/image/icon-pin-outline.svg"
                                                                            alt=""
                                                                        />
                                                                    </IconButton>
                                                                </>
                                                            )}
                                                        </>
                                                    </div>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </>
                            ) : (
                                <>
                                    <div className="lst-number">{index + 1}.</div>
                                    <div
                                        className="lst-text"
                                        onDoubleClick={e => {
                                            if(!isHiddenEditBtn(props)) {
                                                setIsEditItem(true);
                                                setIsEditName(item, true);
                                                return;
                                            }
                                            e.preventDefault();
                                        }}
                                    >
                                        <OverFlowTooltip value={item.name} className={'tag-item-name'}></OverFlowTooltip>
                                        {!isHiddenToolsTagItems(props) && (
                                            <div className="item-formTag">
                                                <>
                                                    <IconButton
                                                        className="itemTools"
                                                        onClick={event => {
                                                            onDuplicateItem(item);
                                                        }}
                                                        disabled={
                                                            props.currentUpdateField
                                                                .affiliationOrganization !==
                                                            props.projectDetail.affiliationOrganization
                                                        }
                                                    >
                                                        <img src="/assets/image/icon-copy.svg" alt="" />
                                                    </IconButton>
                                                    <IconButton
                                                        className="itemTools"
                                                        onClick={event => {
                                                            onDeleteItem(item);
                                                            setCurrentItemSelected(item);
                                                        }}
                                                        disabled={
                                                            props.currentUpdateField
                                                                .affiliationOrganization !==
                                                            props.projectDetail.affiliationOrganization
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-tabs-delete.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                    <IconButton
                                                        className="itemTools"
                                                        onClick={event =>
                                                            onChangeUsingItem(event, item, true)
                                                        }
                                                        disabled={
                                                            props.currentUpdateField
                                                                .affiliationOrganization !==
                                                            props.projectDetail.affiliationOrganization
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-pin-outline.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                </>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </li>
                    );
                })}
            </ul>
        );
    };

    const renderItem = (item, index) => {
        return (
            <>
                {item.isEditName ? (
                    <>
                        {isEditItem ? <div className="lst-number">{index + 1}.</div> : <></>}
                        <TextField
                            // id={`${Date.now().toString()}_textInputName_id`}
                            id={`${item.id}_textInputName_id`}
                            key={`${item.id}_textInputName_key`}
                            placeholder="項目名"
                            onChange={event => {
                                onChangeTextInputName(event, item);
                            }}
                            // autoFocus={Utils.isEmpty(field.isAutoFocus) ? false : field.isAutoFocus}
                            defaultValue={item.name}
                            onKeyPress={event => onKeyPressTextInputName(event, item)}
                            onBlur={event => onBlurTextInput(event, item)}
                            autoFocus={true}
                            disabled={!isEditField(props.currentUpdateField, props)}
                            error={item.isErrorValidate}
                            helperText={item.isErrorValidate ? item.errorMsg : ''}
                            data-cy="tag-item-field-name"
                            className="form-input-outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment>
                                        <div className="item-formTag">
                                            <>
                                                {isEditItem ? (
                                                    <></>
                                                ) : (
                                                    <>
                                                        {!isUseItemInTicket(
                                                            item,
                                                            props.currentUpdateField
                                                        ) && (
                                                            <IconButton
                                                                className="itemTools"
                                                                onClick={event => {
                                                                    onDeleteItem(item);
                                                                    setCurrentItemSelected(item);
                                                                }}
                                                            >
                                                                <img
                                                                    src="/assets/image/icon-tabs-delete.svg"
                                                                    alt=""
                                                                />
                                                            </IconButton>
                                                        )}

                                                        <IconButton
                                                            className="itemTools"
                                                            onClick={event =>
                                                                onChangeUsingItem(
                                                                    event,
                                                                    item,
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                src="/assets/image/icon-pin.svg"
                                                                alt=""
                                                            />
                                                        </IconButton>
                                                    </>
                                                )}
                                            </>
                                        </div>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </>
                ) : (
                    <>
                        <div className="lst-number">{index + 1}.</div>
                        <div
                            className="lst-text"
                            onDoubleClick={e => {
                                if(!isHiddenEditBtn(props)) {
                                    setIsEditItem(true);
                                    setIsEditName(item, true);
                                    return;
                                }
                                e.preventDefault();
                            }}
                        >
                            <OverFlowTooltip value={item.name} className={'tag-item-name'}></OverFlowTooltip>
                            {!isHiddenToolsTagItems(props) && (
                                <div className="item-formTag">
                                    <>
                                        {isShowBtnDuplicateItem(props.currentUpdateField, item) && (
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    onDuplicateItem(item);
                                                }}
                                                disabled={
                                                    props.currentUpdateField.affiliationOrganization !==
                                                    props.projectDetail.affiliationOrganization
                                                }
                                            >
                                                <img src="/assets/image/icon-copy.svg" alt="" />
                                            </IconButton>
                                        )}

                                        {!isUseItemInTicket(item, props.currentUpdateField) && (
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    onDeleteItem(item);
                                                    setCurrentItemSelected(item);
                                                }}
                                                disabled={
                                                    props.currentUpdateField.affiliationOrganization !==
                                                    props.projectDetail.affiliationOrganization
                                                }
                                            >
                                                <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                            </IconButton>
                                        )}

                                        <IconButton
                                            className="itemTools"
                                            onClick={event => onChangeUsingItem(event, item, false)}
                                            disabled={
                                                props.currentUpdateField.affiliationOrganization !==
                                                props.projectDetail.affiliationOrganization
                                            }
                                        >
                                            <img src="/assets/image/icon-pin.svg" alt="" />
                                        </IconButton>
                                    </>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </>
        );
    };

    return (
        <div className="groupManage">
            <div className="headManage">
                <div className="headManage-top">
                    <h2 className="headManage-title">選択項目編集</h2>
                    <div className="headManage-tools">
                        <div className="headManage-btn">
                            <Button
                                className="btn-light btn-hg32"
                                onClick={onCancelAddFieldTagItem}
                                variant="contained"
                                color="default"
                            >
                                閉じる
                            </Button>
                            <Button
                                className="btn-primary btn-hg32"
                                onClick={onSubmitAddFieldTagItem}
                                disabled={isDisableBtnSave}
                                variant="contained"
                                color="primary"
                                data-cy="tag-item-btn-submit-add"
                            >
                                {props.hasOwnProperty('parentCallback') ? I18n.get('SAVE') : I18n.get('COMBTN003')}
                            </Button>
                        </div>
                    </div>
                </div>
                {/* headManage-top */}
            </div>
            {/* headManage */}
            <div className="contentManage">
                <div className="createForm-header">
                    <div className="createForm-field">
                        <div className="createForm-thumb">
                            <img src="/assets/image/icon-field.svg" alt="" />
                        </div>
                        <div className="createForm-control">
                            <TextField
                                className="form-input-outlined"
                                placeholder="フィールド名"
                                value={selectedField?.name}
                                error={!!selectedField?.error}
                                helperText={selectedField?.error}
                                onChange={onChangeFieldName}
                                disabled={isDisableEditTagFieldName(props)}
                            />
                        </div>
                    </div>
                    {/* createForm-field */}
                    <div className="createCustomize">
                        <ul>
                            <li>
                                <label className="createCustomize-label">項目</label>
                                <div className="createCustomize-control">
                                    <TextField
                                        className="form-control--wrap form-control--hg32"
                                        select
                                        variant="outlined"
                                        SelectProps={{
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                getContentAnchorEl: null,
                                                className: 'selectDrop'
                                            }
                                        }}
                                        disabled={
                                            props.currentUpdateField.affiliationOrganization !==
                                                props.projectDetail.affiliationOrganization ||
                                            !isEditField(props.currentUpdateField, props)
                                        }
                                        value={settingSelectItem}
                                        onChange={event => onChangeSettingSelectItem(event)}
                                        data-cy="item-tag-setting-filter"
                                    >
                                        <MenuItem
                                            value={Constant.SETTING_SELECT_ITEM_TAG_FIELD.CUSTOMISE}
                                            data-cy="item-tag-setting-filter-customise"
                                        >
                                            {I18n.get('TAGBTN001')}
                                        </MenuItem>
                                        <MenuItem
                                            value={
                                                Constant.SETTING_SELECT_ITEM_TAG_FIELD
                                                    .MASTER_KNOWLEDGE
                                            }
                                        >
                                            {I18n.get('TAGBTN002')}
                                        </MenuItem>
                                        <MenuItem
                                            value={Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL}
                                        >
                                            {I18n.get('TAGBTN003')}
                                        </MenuItem>
                                        <MenuItem
                                            value={
                                                Constant.SETTING_SELECT_ITEM_TAG_FIELD.SYSTEM_MASTER
                                            }
                                        >
                                            {I18n.get('TAGBTN004')}
                                        </MenuItem>
                                    </TextField>
                                </div>
                            </li>
                            <li>
                                <label className="createCustomize-label">並び順</label>
                                <div className="createCustomize-control">
                                    <TextField
                                        className="form-control--wrap form-control--hg32"
                                        select
                                        variant="outlined"
                                        SelectProps={{
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                getContentAnchorEl: null,
                                                className: 'selectDrop'
                                            }
                                        }}
                                        value={displayOrder}
                                        onChange={event => onChangeDisplayOrder(event)}
                                        disabled={
                                            !isEditField(props.currentUpdateField, props) ||
                                            props.currentUpdateField.affiliationOrganization !==
                                                props.projectDetail.affiliationOrganization ||
                                            isSearchMode
                                        }
                                        data-cy="item-tag-filter-sort-order"
                                    >
                                        <MenuItem
                                            value={Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE}
                                            data-cy="item-tag-filter-sort-order-customise"
                                        >
                                            カスタマイズ
                                        </MenuItem>
                                        <MenuItem
                                            value={
                                                Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER
                                            }
                                        >
                                            辞書順
                                        </MenuItem>
                                        <MenuItem
                                            value={
                                                Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER
                                            }
                                        >
                                            ヒット件数順
                                        </MenuItem>
                                    </TextField>
                                </div>
                            </li>
                        </ul>
                    </div>

                    {[
                        Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
                        Constant.SETTING_SELECT_ITEM_TAG_FIELD.CUSTOMISE
                    ].includes(settingSelectItem) && (
                        <>
                            {/* createForm-customize */}
                            <div className="createForm-tools">
                                <div className="createForm-item">
                                    {isDisplayTools() && (
                                        <ExportUploader
                                            targetUploadId={props?.currentUpdateField?.id}
                                            displayDownloader={true}
                                            disableDownloader={isDisableTools()}
                                            displayUploader={true}
                                            disableUploader={isDisableTools()}
                                            displayLogger={true}
                                            disableLogger={isDisableTools()}
                                            downloadHandler={() =>
                                                downloadTagItems({
                                                    corporationInuseId:
                                                        props?.projectDetail
                                                            ?.affiliationOrganization,
                                                    projectInuseId: props?.projectDetail?.id,
                                                    userInuseId: props?.userDetail?.id,
                                                    tagFieldDownloaderId:
                                                        props?.currentUpdateField?.id
                                                })
                                            }
                                            uploadHandler={uploadTagItems}
                                        />
                                    )}
                                </div>
                                <div className="createForm-addManage">
                                    {!isHiddenEditBtn(props) && (
                                        <IconButton
                                            className="itemNav"
                                            aria-label="more"
                                            id="long-button"
                                            aria-controls={open ? 'long-menu' : undefined}
                                            aria-expanded={open ? 'true' : undefined}
                                            aria-haspopup="true"
                                            variant="contained"
                                            color="primary"
                                            onClick={event => onAddItem(event)}
                                            disabled={isDisableTools()}
                                            data-cy="field-tag-item-btn-add"
                                        >
                                            <img src="/assets/image/icon-add-manage.svg" alt="" />
                                        </IconButton>
                                    )}
                                    <Popover
                                        className="nav-addManage"
                                        id={open ? 'simple-popover' : undefined}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        }}
                                    >
                                        <ul>
                                            <li className="active">
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-add-plus-manage.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">問い合わせ</span>
                                            </li>
                                            <li>
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-add-plus-manage.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">お知らせ</span>
                                            </li>
                                            <li>
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-add-plus-manage.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">課題</span>
                                            </li>
                                            <li>
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-add-plus-manage.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">ナレッジ</span>
                                            </li>
                                            <li>
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-add-plus-manage.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">マスター</span>
                                            </li>
                                        </ul>
                                    </Popover>
                                </div>
                            </div>
                            {isDisplayTools() && (
                                <div className="createForm-tools">
                                    <div className="createForm-item">
                                        <TextField
                                            className="form-input-outlined form-input-search"
                                            placeholder={I18n.get(
                                                'MSG-TAG-ITEM-SEARCH-PLACEHOLDER'
                                            )}
                                            value={searchKeyword}
                                            onChange={event =>
                                                handleSearchInputChange(event, setSearchKeyword)
                                            }
                                            onKeyPress={event =>
                                                handleSearchKeyPress(
                                                    event,
                                                    searchKeyword,
                                                    handleSearchTagItems
                                                )
                                            }
                                            fullWidth
                                            variant="outlined"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <IconButton
                                                            onClick={() =>
                                                                handleSearchIconClick(
                                                                    searchKeyword,
                                                                    handleSearchTagItems
                                                                )
                                                            }
                                                            edge="start"
                                                            size="small"
                                                        >
                                                            <img
                                                                src="/assets/image/icon-searchFrame.svg"
                                                                alt=""
                                                            />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                            {!Utils.isEmptyString(searchError) && (
                                <div className="createForm-tools">
                                    <span className="search-warning">
                                        <img src="/assets/image/icon-listEmpty.svg" alt="" />{' '}
                                        {searchError}
                                    </span>
                                </div>
                            )}
                            {/* createForm-tools */}
                            {/* createForm-header */}
                            <div
                                className={
                                    !useButtonCollapse
                                        ? 'accordionForm accordionForm--show'
                                        : 'accordionForm'
                                }
                            >
                                {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                                <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                                    <span className="accordionHead-item">
                                        <img src="/assets/image/icon-pin.svg" alt="" />
                                    </span>
                                    <span className="accordionHead-text">
                                        以下の選択項目は使用する ({itemUsingList.length})
                                    </span>
                                </div>
                                <div className="accordionContent">
                                    <div className="lst-formTag">
                                        {renderItemListWithUsingProject()}
                                    </div>
                                    {/* lst-formTag */}
                                </div>
                            </div>
                            {/* accordionForm */}
                            <div
                                className={
                                    !unUseButtonCollapse
                                        ? 'accordionForm accordionForm--show'
                                        : 'accordionForm'
                                }
                            >
                                {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                                <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                                    <span className="accordionHead-item">
                                        <img src="/assets/image/icon-pin-outline.svg" alt="" />
                                    </span>
                                    <span className="accordionHead-text">
                                        以下の選択項目は使用しない ({itemNotUsingList.length})
                                    </span>
                                </div>
                                <div className="accordionContent">
                                    <div className="lst-formTag">
                                        {renderItemListWithNotUsingProject()}
                                    </div>
                                    {/* lst-formTag */}
                                </div>
                            </div>
                            {/* accordionForm */}
                        </>
                    )}

                    {settingSelectItem === Constant.SETTING_SELECT_ITEM_TAG_FIELD.SYSTEM_MASTER && (
                        <RenderTagItemSystemMaster
                            indexAddField={indexAddField}
                            currentField={props.fieldAddList[indexAddField]}
                            props={props}
                        />
                    )}

                    {/* master field */}
                    {settingSelectItem ===
                        Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE && (
                        <MasterKnowledge
                            {...props}
                            displayOrder={displayOrder}
                            masterKnowledge={masterKnowledge}
                            setMasterKnowledge={setMasterKnowledge}
                            setIsDisableBtnSave={setIsDisableBtnSave}
                        />
                    )}
                    {/* master field auto fill */}
                    {settingSelectItem === Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL && (
                        <AutoFillMasterField
                            {...props}
                            displayOrder={displayOrder}
                            autoFillMasterField={autoFillMasterField}
                            setAutoFillMasterField={setAutoFillMasterField}
                        />
                    )}
                </div>
            </div>
            {/* contentManage */}

            {/* UnsavedChangesDialog */}
            <UnsavedChangesDialog
                isOpen={props?.isOpenUnsavedChangesDialog}
                messageConfirm={
                    formPanelTabClose.isClosePanel
                        ? I18n.get('MSG-CONFIRM-CLOSE-PANEL')
                        : I18n.get('MSG-CM-CONFIRM-CANCEL-FORM-FIELD-CHANGE')
                }
                closeCallBack={() => {
                    props?.setIsOpenUnsavedChangesDialog(false);

                    // reset field name to initial value
                    const originalName = initialFieldNameRef.current;
                    setSelectedField({ name: originalName, error: '' });
                    let cloneFieldAddList = [...props.fieldAddList];
                    cloneFieldAddList[indexAddField].name = { jp: { A: 'F', text: originalName } };
                    cloneFieldAddList[indexAddField].errors = { ...cloneFieldAddList[indexAddField].errors, name: {} };
                    props.setFieldAddList(cloneFieldAddList);

                    setFormPanelTabClose(prev => {
                        let isDirty = false;
                        const currentUpdateField = props.currentUpdateField;
                        if (!Utils.isEmptyObject(currentUpdateField)) {
                            // if createNew, not update isDirty = false
                            isDirty = currentUpdateField?.id?.includes('dummy');
                        }
                        return ({
                            isDirty: isDirty,
                            isClosePanel: false,
                            isCloseScreen: false
                        })
                    });
                    if (formPanelTabClose.isClosePanel) {
                        closePanelFormManagement({
                            panelList,
                            setPanelList,
                            currentIndex,
                            setCurrentIndex
                        });
                        return;
                    }
                    if (formPanelTabClose.isCloseScreen) {
                        // Close button: back to parent screen
                        props.setPanelScreen(props.parentPanelScreen);
                        setItemDuplicateList([]);
                        return;
                    }
                    // Tab switch
                    const preSelectedTab = props?.tabSelected;
                    props?.setTabSelected(
                        preSelectedTab === Constant.TAB_FORM_MANAGEMENT.FIELD
                            ? Constant.TAB_FORM_MANAGEMENT.FORM
                            : Constant.TAB_FORM_MANAGEMENT.FIELD
                    );
                }}
                closeBtnText={I18n.get('OK')}
                cancelCallBack={() => {
                    props?.setIsOpenUnsavedChangesDialog(false);
                    setFormPanelTabClose(prev => ({
                        ...prev,
                        isClosePanel: false,
                        isCloseScreen: false
                    }));
                }}
                cancelBtnText={I18n.get('CANCEL')}
            />

            {/* dialog confirm delete item*/}
            <Dialog
                open={isDialogDeleteItem}
                onClose={(event, reason) => onClickBtnCloseDialogDeleteItem(event, reason)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="wrapDialog"
                // disableBackdropClick="true"
            >
                {/* <DialogTitle className="titleHeader">
                    <h2 className="title">{I18n.get('COMLB001')}</h2>
                </DialogTitle> */}
                <DialogContent>
                    <div className="confirm-dialog-content">{I18n.get('TAGMSG002')}</div>
                </DialogContent>
                <DialogActions className="confirm-dialog-action">
                    {/* btn submit */}
                    <Button
                        className="confirm-dialog-button"
                        variant="contained"
                        color="primary"
                        onClick={onSubmitDeleteFieldTagItem}
                    >
                        {I18n.get('COMBTN002')}
                    </Button>
                    {/* btn close */}
                    <Button
                        className="confirm-dialog-button"
                        variant="contained"
                        color="primary"
                        onClick={onClickBtnCloseDialogDeleteItem}
                    >
                        {I18n.get('COMBTN007')}
                    </Button>
                </DialogActions>
            </Dialog>

            <ConfirmDialog
                isOpen={dialogNotificationWithMsg?.status}
                msgConfirm={dialogNotificationWithMsg?.msg}
                okCallBack={() =>
                    setDialogNotificationWithMsg(pre => {
                        return {
                            ...pre,
                            status: false
                        };
                    })
                }
            />

            <ConfirmDialog
                isOpen={!Utils.isEmptyArray(itemDuplicateList)}
                msgConfirm={
                    <div>
                        {I18n.get('MSG_DUPLICATE_TAG_NAME')}
                        <br />
                        {`{${itemDuplicateList.join('、')}}`}
                    </div>
                }
                textSubmit={I18n.get('COMBTN002')}
                okCallBack={() => confirmPopupDuplicateItem()}
                className={!Utils.isEmptyArray(itemDuplicateList) ? '' : 'd-hidden'}
            />
        </div>
    );
}
